import { NavLink } from 'react-router'
import styled from 'styled-components'

export const SearchRedirect = styled(NavLink)`
  display: flex;
  flex-direction: row;
  color: ${(props) => props.theme.colors.whiteAlpha50};
`
export const IconWrapper = styled.div`
  flex: 0;
  padding: 0 0.5rem;
`

export const SpanUnselect = styled.span`
  font-size: 1rem;
  cursor: pointer;
  color: ${(props) => props.theme.colors.whiteAlpha50};
  padding: 0.5rem;
  vertical-align: middle;
  &:hover {
    color: ${(props) => props.theme.colors.errorColor500};
  }
`
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`
export const Title = styled.div`
  color: ${(props) => props.theme.colors.white};
  font-weight: 700;
`
export const Subtitle = styled.span`
  color: ${(props) => props.theme.colors.whiteAlpha50};
  font-weight: 500;
`
